import axios from "axios";
import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import toast from "react-hot-toast";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {

        e.preventDefault();
        const id = toast.loading("Sending reset link...");
        // Here you would handle sending reset link (API call)
        setMessage("If this email is registered, you'll receive a reset link.");
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://admin.tulikaarts.in/api/forgot-password',

            data: {
                email:email
            }
        };

        axios.request(config)
            .then((response) => {
                setTimeout(() => {
                    toast.success(response.data.message, { id });
                }, 1000);
            })
            .catch((error) => {
                toast.error(error.response.data.message, { id });
            });

    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <div className="w-50 p-4 border rounded shadow bg-white">
                <h3 className="mb-3 text-center">Forgot Password</h3>
                {message && <Alert variant="info">{message}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <input
                            className="form-control"
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100">
                        Reset Password
                    </Button>
                </Form>
                <p className="mt-3 text-muted text-center">
                    You will receive an email with instructions to reset your password.
                </p>
            </div>
        </Container>
    );
};

export default ForgotPassword;
